import { render, staticRenderFns } from "./WalletList.vue?vue&type=template&id=17a29128"
import script from "./WalletList.vue?vue&type=script&lang=js"
export * from "./WalletList.vue?vue&type=script&lang=js"
import style0 from "./WalletList.vue?vue&type=style&index=0&id=17a29128&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports